import { push } from '@lagunovsky/redux-react-router';
import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Alert, Button } from 'reactstrap';
import { ActionTokenParams } from '../';
import { myProfileSettingsPath } from '../../../../screens/UserProfileScreen';
import { Section, SectionHeading } from '../../../common/Section';
import { actionTokenExecute } from '../actions';
import { actionTokenIsExecutedSelector } from '../selectors';

export const CancelAllNotifications: FC<ActionTokenParams> = props => {
    const dispatch = useDispatch();

    const isExecuted = useSelector(actionTokenIsExecutedSelector);

    const onCancel = () => {
        dispatch(push('/'));
    };

    const onExecute = () => {
        if (props.atId && props.uId && props.secId) {
            dispatch(actionTokenExecute({ atId: props.atId, uId: props.uId, secId: props.secId }));
        }
    };

    return (
        <Section>
            <SectionHeading>Benachrichtigungen ausschalten</SectionHeading>
            <p>
                Mit dieser Aktion schalten Sie alle Benachrichtigungen aus. Sie erhalten z.B. keine Newsletter und keine
                Tipperinnerungen mehr.
            </p>
            <p>
                Sie können den Newsletter oder die Tipperinnerungen auch einzeln ausschalten. Wechseln Sie dafür zu
                Profilseite.{' '}
            </p>
            {!isExecuted && (
                <>
                    <Button color="danger" className="me-3" onClick={onExecute}>
                        Alle Benachrichtigungen ausschalten
                    </Button>
                    <Button onClick={onCancel}>Benachrichtigungen beibehalten</Button>
                </>
            )}
            {isExecuted && (
                <Alert color="info">
                    Der Benachrichtigungen wurde ausgeschaltet. Sie können diesen jederzeit wieder über ihr
                    <Link to={myProfileSettingsPath()}>Profile</Link> aktivieren.
                </Alert>
            )}
        </Section>
    );
};
